import React from 'react';
import { getContrastTextColor } from '../utils/colorUtils';

interface BuilderButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  onClick?: () => void;
  className?: string;
  accentColor?: string; // Hex color for button background
}

export const BuilderButton: React.FC<BuilderButtonProps> = ({
  children,
  variant = 'primary',
  onClick,
  className = '',
  accentColor = '#FACC15', // Default yellow-400
}) => {
  const baseStyles =
    'px-6 py-2 rounded-full font-bold uppercase tracking-wide shadow-lg transition-all text-sm';

  // Determine text color based on background for optimal contrast
  const textColor = getContrastTextColor(accentColor);
  const textColorClass = textColor === 'white' ? 'text-white' : 'text-black';

  return (
    <button
      onClick={onClick}
      className={`${baseStyles} ${textColorClass} ${className}`}
      style={{
        backgroundColor: accentColor,
      }}
      type="button"
    >
      {children}
    </button>
  );
};
